import { render } from "./ImageTextBlockPhone.vue?vue&type=template&id=63ac74e2&scoped=true"
import script from "./ImageTextBlockPhone.vue?vue&type=script&lang=js"
export * from "./ImageTextBlockPhone.vue?vue&type=script&lang=js"

import "./ImageTextBlockPhone.vue?vue&type=style&index=0&id=63ac74e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ac74e2"]])

export default __exports__